import { render, staticRenderFns } from "./material-group-wrap.vue?vue&type=template&id=1622955f&scoped=true&"
import script from "./material-group-wrap.vue?vue&type=script&lang=js&"
export * from "./material-group-wrap.vue?vue&type=script&lang=js&"
import style0 from "./material-group-wrap.vue?vue&type=style&index=0&id=1622955f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1622955f",
  null
  
)

export default component.exports